import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { getDefaultPagination, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const DataMaintenanceApi = {
  getImages: (
    action: { page: number; limit: number; materialCode?: string },
    dispatch: Dispatch
  ) => {
    const requestBody = action.materialCode ? [action.materialCode] : [];
    const queryParams =
      `${EUrlParams.Page}=` + action.page + `&${EUrlParams.Limit}=` + action.limit;
    return AxiosClient.post(`/product/v1/images/read?${queryParams}`, requestBody)
      .then((response) => {
        return handlePaginatedData(
          { ...response, data: response.data.productImages },
          { ...action, searchCode: action.materialCode }
        );
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.materialCode },
          EAction.Read,
          EApiType.ImagesKey
        );
      });
  },

  getCountryList: (dispatch: Dispatch) => {
    const queryParams = getDefaultPagination('market');
    return AxiosClient.post(`/market/v1/read?${queryParams}`, [])
      .then((response) => {
        return {
          data: response.data,
        };
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },
};
